import { Loader2, Globe } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

interface ClientIpCardProps {
  ip?: string;
  provider?: string;
  isLoading: boolean;
  onIpClick: (ip: string) => void;
}

export function ClientIpCard({
  ip,
  provider,
  isLoading,
  onIpClick,
}: ClientIpCardProps) {
  if (isLoading) {
    return (
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <Loader2 className="w-5 h-5 animate-spin text-muted-foreground" />
            <div className="space-y-2 flex-1">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="h-4 w-48" />
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Globe className="w-5 h-5 text-primary" />
          </div>
          <div className="min-w-0">
            <button
              onClick={() => ip && onIpClick(ip)}
              className="text-lg font-semibold text-primary hover:underline"
            >
              {ip || '—'}
            </button>
            <p className="text-sm text-muted-foreground truncate">
              {provider || 'Unknown provider'}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
